import React from 'react';
import { UnitTimersStore } from './unit-timers-store';

export const UnitTimersStoreContext = React.createContext<undefined | UnitTimersStore>(undefined);
